
import getSchema from './../../data/getSchema'
import { addFile } from './../files/actions'
import { setLoading } from './../loading/reducer'
import { addError } from './../errors/actions'
import commitFiles from './../../data/commitFiles'
import { addBranch } from './../branches/actions'
import createBranch from './../../data/createBranch'
import { moveFile } from './../files/actions'
import { setSelectedBranch } from './../repositories/actions'

export default ({ dispatch, getState }) => next => async action => {

  if (action.type === 'LOAD_SCHEMA'){
    const { branchId } = action.payload
    // Already loading or has been loaded
    if (`${branchId}-schema` in getState().loading) return
    dispatch(setLoading(`${branchId}-schema`, true))
    try {
      var file = await getSchema(getState().token, branchId)
    } catch (err){
      if (err.code)
        dispatch(addError(err))
      throw err
    } finally {
      dispatch(setLoading(`${branchId}-schema`, false))
    }
    dispatch(addFile(file, branchId))
  }

  if (action.type === 'SAVE_FILES'){
    const { branchId, files, commitMessage } = action.payload
    if (getState().loading[`${branchId}-saving`]) return
    dispatch(setLoading(`${branchId}-saving`, true))
    try {
      await commitFiles(getState().token, branchId, files, commitMessage)
    } catch (err){
      if (err.code)
        dispatch(addError(err))
      throw err
    } finally {
      dispatch(setLoading(`${branchId}-saving`, false))
    }
  }

  if (action.type == 'CREATE_BRANCH'){
    const { currentBranchId, newBranchName, repositoryId } = action.payload
    if (getState().loading[`creating-branch`]) return
    dispatch(setLoading(`creating-branch`, true))
    try {
      var newBranch = await createBranch(getState().token, currentBranchId, newBranchName, repositoryId)

      var { schema: currentBranchSchemaId } = getState().branches[currentBranchId]

      // Put the last commit version of the files back for the old branch
      // This has a little bit of uncessary overhead as we're moving all the
      // current files and then fetching all the old files when really we only
      // need to transfer the uncommitted ones over but this is the simplest
      // solution for now
      var oldBranchFiles = await Promise.all([
        await getSchema(getState().token, currentBranchId),
      ])
      dispatch([
        addBranch(newBranch),
        // Move over old branch files to the new branch
        moveFile(getState().files[currentBranchSchemaId], currentBranchId, newBranch.id),
        ...oldBranchFiles.map(file => addFile(file, currentBranchId)),
        setSelectedBranch(newBranch.id, repositoryId),
      ])

    } catch (err){
      if (err.code)
        dispatch(addError(err))
      throw err
    } finally {
      dispatch(setLoading(`creating-branch`, false))
    }
  }

  if (action.type == 'CREATE_BRANCH_AND_SAVE_FILES'){
    const { currentBranchId, newBranchName, files, commitMessage, repositoryId } = action.payload
    if (getState().loading[`${currentBranchId}-saving`]) return
    dispatch(setLoading(`${currentBranchId}-saving`, true))
    try {
      var newBranch = await createBranch(getState().token, currentBranchId, newBranchName, repositoryId)
      await commitFiles(getState().token, newBranch.id, files, commitMessage)
      // Get all the files for the current branch, as we want to remove the uncommitted
      // changes as those changes will be added to the new branch. At the moment there
      // is only the schema file
      var oldFiles = await Promise.all([
        await getSchema(getState().token, currentBranchId)
      ])

      dispatch([
        addBranch(newBranch),
        // Move files over to new branch
        ...files.map(f => moveFile(f, currentBranchId, newBranch.id)),
        // Return old branch files
        ...oldFiles.map(f => addFile(f, currentBranchId)),
        setSelectedBranch(newBranch.id, repositoryId),
      ])
    } catch (err){
      if (err.code)
        dispatch(addError(err))
      throw err
    } finally {
      dispatch(setLoading(`${currentBranchId}-saving`, false))
    }


  }

  /*if (action.type === 'SAVE_UNCOMMITTED_CHANGES_TO_NEW_BRANCHES'){
    const { currentBranchId, newBranchName } = action.payload
    if (getState().loading[`${currentBranchId}-saving`]) return
    dispatch(setLoading(`${currentBranchId}-saving`, true))

    try {
      var branch = await createNewBranch(repositoryId, newBranchName)
    } catch (err){
      if (err.code)
        dispatch(addError(err))
      throw err
    }
    addBranch(branch)

    var files = getUncommittedFiles(currentBranchId)
    try {
      await commitChanges(files, commitMessage)
    } catch (err){
      if (err.code)
        dispatch(addError(err))
      throw err
    }
    dispatch(setLoading(`${currentBranchId}-saving`, false))
  }*/

  return next(action)

}


// WEBPACK FOOTER //
// ./src/store/branches/middleware.js